import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Sponsorzy() {
  useDocumentTitle("Sponsorzy", "Poznaj sponsorów i partnerów mamy!kongres — marki, które wspierają mamy z całej Polski.");
  return (
    <div data-testid="sponsors-page">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-8 pb-14 relative">
        <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-[#E6007A]/15 blur-3xl pointer-events-none" />
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-6 relative">
          Sponsorzy i partnerzy
        </div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] mb-8 relative">
          Marki, które <br />
          <span className="italic text-[#E6007A]">wierzą</span> w mamy.
        </h1>
        <p className="text-xl text-[#5C534D] leading-relaxed max-w-3xl relative">
          mamy!kongres powstaje przy wsparciu firm i instytucji, którym bliska jest rodzina.
          Z dumą pokażemy je w tym miejscu — lista rośnie z każdym tygodniem.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <div
              key={n}
              data-testid={`sponsor-slot-${n}`}
              className="rounded-[32px] border-2 border-dashed border-[#F4B7CA] bg-[#FDFBF7] aspect-[3/2] grid place-items-center text-center px-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div>
                <div className="font-display text-2xl text-[#E6007A]/60 mb-2">Twoje logo</div>
                <div className="text-sm text-[#5C534D]">może znaleźć się właśnie tutaj</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-24 text-center">
        <h2 className="font-display text-3xl md:text-4xl mb-4">
          Chcesz zobaczyć tu swoją markę?
        </h2>
        <p className="text-[#5C534D] leading-relaxed mb-8 max-w-2xl mx-auto">
          Porozmawiajmy o współpracy — pokażemy Ci, jak dotrzeć do setek świadomych,
          zaangażowanych mam z całej Polski.
        </p>
        <Link
          to="/wspolpraca"
          data-testid="sponsors-cta-cooperation"
          className="btn-lift inline-flex items-center gap-3 rounded-full bg-[#E6007A] px-10 py-5 text-white font-semibold text-lg"
        >
          Zobacz możliwości współpracy
          <ArrowRight className="w-5 h-5" />
        </Link>
      </section>
    </div>
  );
}
